import { BLANK_VALUE, DEFAULT_DATE_FORMAT } from "./constants";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc.js"; // Import UTC plugin
import timezone from "dayjs/plugin/timezone.js"; // Import UTC plugin
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Kolkata");

export const setDataToLocalStorage = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const getDataFromLocalStorage = (key) => {
  return JSON.parse(localStorage.getItem(key));
};

export const isEmpty = (value) => {
  if (
    value === null ||
    value === undefined ||
    value === BLANK_VALUE ||
    value === ""
  ) {
    return true;
  }
  return false;
};

export const disableFutureDates = (current) => {
  return current && current.valueOf() > dayjs().tz("Asia/Kolkata").endOf("day");
};

export const formatDateToDayJS = (date) => {
  return date ? dayjs(date).tz("Asia/Kolkata") : null;
};

export const formatDateToDisplay = (date) => {
  return date
    ? dayjs(date).tz("Asia/Kolkata").format("DD MMM YYYY")
    : null;
};

export const getUserRole = () => {
  let user = JSON.parse(localStorage.getItem("user"));
  return user ? user.role : null;
};

export const convertToPascalCase = (text) => {
  return text.replace(/\w+/g,
    function (w) { return w[0].toUpperCase() + w.slice(1).toLowerCase(); });
}

export const formatBreadcrumbText = (name) => {
  let formatedText = convertToPascalCase(name.replaceAll("-", " "));
  return formatedText;
}
export const splitArrayIntoChunks = (arr, chunkSize) => {
  const result = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    result.push(arr.slice(i, i + chunkSize));
  }
  return result;
}